(function() {
    // Initialize all sliders when DOM is ready
    function initAllSliders() {
        const sliders = document.querySelectorAll('.pb-cardslide');
        
        sliders.forEach((slider, sliderIndex) => {
            initSingleSlider(slider, sliderIndex);
        });
    }
    
    // Initialize individual slider
    function initSingleSlider(sliderContainer, sliderIndex) {
        const images = sliderContainer.querySelectorAll('.custom-card__image');
        const dotsContainer = sliderContainer.querySelector('.slider-dots');
        const prevBtn = sliderContainer.querySelector('.prev-btn');
        const nextBtn = sliderContainer.querySelector('.next-btn');
        
        let currentSlide = 0;
        
        // Skip if only one image
        if (images.length <= 1) {
            sliderContainer.setAttribute('data-single-image', 'true');
            return;
        }
        
        // Create dots
        images.forEach((_, index) => {
            const dot = document.createElement('span');
            dot.className = 'dot';
            if (index === 0) dot.classList.add('active');
            dot.addEventListener('click', () => goToSlide(index));
            dotsContainer.appendChild(dot);
        });
        
        // Show specific slide
        function showSlide(index) {
            images.forEach((img, i) => {
                img.classList.toggle('active', i === index);
            });
            
            const dots = dotsContainer.querySelectorAll('.dot');
            dots.forEach((dot, i) => {
                dot.classList.toggle('active', i === index);
            });
            
            currentSlide = index;
        }
        
        // Change slide by direction
        function changeSlide(direction) {
            const newSlide = (currentSlide + direction + images.length) % images.length;
            showSlide(newSlide);
        }
        
        // Go to specific slide
        function goToSlide(index) {
            showSlide(index);
        }
        
        // Add event listeners
        prevBtn.addEventListener('click', (e) => {
            e.preventDefault();
            changeSlide(-1);
        });
        
        nextBtn.addEventListener('click', (e) => {
            e.preventDefault();
            changeSlide(1);
        });
        
        // Touch/swipe support
        let startX = 0;
        let endX = 0;
        
        sliderContainer.addEventListener('touchstart', (e) => {
            startX = e.touches[0].clientX;
        });
        
        sliderContainer.addEventListener('touchend', (e) => {
            endX = e.changedTouches[0].clientX;
            handleSwipe();
        });
        
        function handleSwipe() {
            const threshold = 50;
            const diff = startX - endX;
            
            if (Math.abs(diff) > threshold) {
                if (diff > 0) {
                    changeSlide(1); // Swipe left - next image
                } else {
                    changeSlide(-1); // Swipe right - previous image
                }
            }
        }
        
        // Auto-slide (optional - uncomment if you want auto-sliding)
        /*
        setInterval(() => {
            changeSlide(1);
        }, 4000);
        */
        
        // Pause auto-slide on hover (if auto-slide is enabled)
        /*
        sliderContainer.addEventListener('mouseenter', () => {
            clearInterval(autoSlideInterval);
        });
        
        sliderContainer.addEventListener('mouseleave', () => {
            autoSlideInterval = setInterval(() => {
                changeSlide(1);
            }, 4000);
        });
        */
    }
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAllSliders);
    } else {
        initAllSliders();
    }
    
    // Re-initialize if new content is loaded dynamically (for AJAX loading)
    document.addEventListener('shopify:section:load', initAllSliders);
})();
